<app-lms-modal-frame [title]="'Maximum Loans Exceeded'" [pageHeadWidth]="450">
    <div>&nbsp;</div>

    <div *ngIf="wageFrequency=='Monthly' " modal-body class="myh-300 py-3 px-1 text-center">
        <h6>This client already has 4 active loans. </h6>
        <h6>A {{clientType}} client cannot have more than 4 active loans at a time.</h6>
    </div>

    <div *ngIf="wageFrequency =='Weekly' || wageFrequency =='Fortnightly'" modal-body class="myh-300 py-3 px-1 text-center">
        <h6>This client already has 2 active loans. </h6>
        <h6>A {{wageFrequency}} client cannot have more than 2 active loans at a time.</h6>
    </div>

    <div modal-body class="myh-300 py-3 px-1 text-center">
        <h6>Please check on Delfin if any of these loans are paid up.</h6>
        <h6>Then exclude these Internal loans on the list. </h6>
    </div>

    <div modal-actions class="lms-action-bar">
        <button class="btn btn-sm btn-primary m-2" mdbRipple color="primary" (click)="close()"> Close </button>
    </div>

    <div>

    </div>
</app-lms-modal-frame>
